import { useTranslation } from 'react-i18next';
import { Lock } from 'lucide-react';
import { useFeatures } from '../lib/useFeatures';

// Route guard: render children only if the current client has `feature` enabled.
// Otherwise show a "module not enabled" screen (the SaaS 403). Pair a route with
// its module, e.g. <RequireFeature feature="material_management"><Materials /></RequireFeature>.
// Feature flags gate whole modules per client; RequirePerm gates actions per role.
export default function RequireFeature({ feature, children }) {
  const { hasFeature, loading } = useFeatures();
  const { t } = useTranslation();
  if (loading) return null; // wait for the flag set before deciding

  if (!hasFeature(feature)) {
    return (
      <div className="flex flex-col items-center justify-center h-[60vh] text-center px-4">
        <Lock className="w-16 h-16 text-[#6d7d8b] mb-4" />
        <h2 className="text-2xl font-bold text-[#1d2d3d]">
          {t('features.notEnabledTitle', 'Módulo no disponible')}
        </h2>
        <p className="text-[#6d7d8b] mt-1 max-w-md">
          {t('features.notEnabledBody', 'Este módulo no está activado para tu cuenta. Contacta con el administrador para habilitarlo.')}
        </p>
      </div>
    );
  }
  return children;
}
